import React from 'react';
import { methodSteps } from '../../data/method';
export function Method() {
  return <section aria-labelledby="method-title" className="bg-ink py-20 text-paper lg:py-28" data-id="element-114" data-mp="1rtwxvbnmdpvh">
      <div className="mx-auto max-w-site px-6 lg:px-10" data-id="element-115" data-mp="1vw1l9snh5q9o">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-116" data-mp="1vugqq315u7bt">
          <h2 id="method-title" className="font-serif text-4xl leading-tight tracking-tight lg:col-span-5 lg:text-5xl" data-id="element-117" data-mp="20ve8iei9czcs">
            Une méthode éprouvée, du diagnostic à l’évaluation
          </h2>
          <p className="text-[17px] leading-relaxed text-paper/70 lg:col-span-6 lg:col-start-7 lg:pt-3" data-id="element-118" data-mp="2asiuoec3sutl">
            Chaque mission s’inscrit dans un cycle continu. Nous restons aux côtés des maîtres d’ouvrage au-delà
            de la remise des études, pour que les orientations décidées se traduisent concrètement sur le terrain.
          </p>
        </div>

        <ol className="mt-16 grid gap-px bg-paper/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-119" data-mp="2oicn16mthx82">
          {methodSteps.map((step, index) => <li key={step.title} className="flex flex-col bg-ink pt-8 sm:pr-8" data-id="element-120" data-mp="3bmii0ffesvw0" data-mpi={index}>
              <span className="font-serif text-lg text-accent-light" aria-hidden="true" data-id="element-121" data-mp="36mw4s5zkzfn7">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-6 font-serif text-2xl leading-snug" data-id="element-122" data-mp="32ludcbbwo7vs">{step.title}</h3>
              <p className="mt-4 pb-8 text-[15px] leading-relaxed text-paper/70" data-id="element-123" data-mp="2xnj52519e5fo">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}